import { X } from 'lucide-react';
import type { QuestType } from '../../services/questTypes';

interface QuestResultFiltersProps {
    questTypes: QuestType[];
    journeyDays: number[];
    selectedQuestType: QuestType | '';
    selectedJourneyDay: number | '';
    selectedUserId: string;
    onQuestTypeChange: (questType: QuestType | '') => void;
    onJourneyDayChange: (journeyDay: number | '') => void;
    onUserIdChange: (userId: string) => void;
}

export const QuestResultFilters = ({
    questTypes,
    journeyDays,
    selectedQuestType,
    selectedJourneyDay,
    selectedUserId,
    onQuestTypeChange,
    onJourneyDayChange,
    onUserIdChange,
}: QuestResultFiltersProps) => {
    const handleQuestTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const value = e.target.value as QuestType | '';
        onQuestTypeChange(value);
    };

    const handleJourneyDayChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const value = e.target.value === '' ? '' : Number(e.target.value);
        onJourneyDayChange(value);
    };

    const handleUserIdChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        onUserIdChange(e.target.value);
    };

    return (
        <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-200">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">

                {/* User ID Filter */}
                <div className="flex flex-col">
                    <label htmlFor="user-id" className="text-sm font-medium text-gray-700 mb-1">
                        User ID
                    </label>
                    <div className="relative">
                        <input
                            id="user-id"
                            type="text"
                            value={selectedUserId}
                            onChange={handleUserIdChange}
                            placeholder="Enter or paste user ID"
                            className="w-full px-3 py-2 pr-10 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        />
                        {selectedUserId && (
                            <button
                                type="button"
                                onClick={() => onUserIdChange('')}
                                className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 focus:outline-none"
                                aria-label="Clear user ID"
                            >
                                <X className="w-5 h-5" />
                            </button>
                        )}
                    </div>
                </div>
                {/* Quest Type Filter */}
                <div className="flex flex-col">
                    <label htmlFor="quest-type" className="text-sm font-medium text-gray-700 mb-1">
                        Quest Type
                    </label>
                    <select
                        id="quest-type"
                        value={selectedQuestType}
                        onChange={handleQuestTypeChange}
                        className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    >
                        <option value="">All Types</option>
                        {questTypes.map((type) => (
                            <option key={type} value={type}>
                                {type}
                            </option>
                        ))}
                    </select>
                </div>

                {/* Journey Day Filter */}
                <div className="flex flex-col">
                    <label htmlFor="journey-day" className="text-sm font-medium text-gray-700 mb-1">
                        Journey Day
                    </label>
                    <select
                        id="journey-day"
                        value={selectedJourneyDay}
                        onChange={handleJourneyDayChange}
                        className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    >
                        <option value="">All Days</option>
                        {journeyDays.map((day) => (
                            <option key={day} value={day}>
                                Day {day}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
        </div>
    );
};